import { AfterViewInit, Component, EventEmitter, Output, inject } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-update-pin',
    templateUrl: './update-pin.component.html',
    styleUrls: ['./update-pin.component.css'],
    standalone: false
})
export class UpdatePinComponent implements AfterViewInit {
  authService = inject(AuthService);

  @Output() submitted = new EventEmitter<string>();
  showDialog = false;
  pincode = "";
  confirmPincode = "";
  isError = false;
  msg="";
  disablePinCodeUpdate = environment.disablePincodeUpdate;


  ngAfterViewInit(): void {
    setTimeout(() => this.checkPinCode90Days(),1000)
  }

  savePincode(){
    this.authService.updatePinCode(this.pincode).subscribe({
      next: () => {
        this.pincode = "";
        this.confirmPincode = "";
        this.authService.pincodeUpdatedOnThisSession = true;
        this.submitted.emit("SUCCESS");
        this.showDialog = false;
      },
      error: (error) => {
        this.pincode = "";
        this.confirmPincode = "";
        this.isError = true;
        if (error.error.message == 'Please use a different pincode than the previous used.')
          this.submitted.emit("PREVIOUSPINCODEMATCH");
        else
          this.submitted.emit("FAILURE");
        this.showDialog = false;
      }
    });
  }

  checkPinCode90Days(){
    if(this.authService.pincodeUpdatedOnThisSession)
    return
    const dateString = this.authService.user.witnessLastUpdatedAt||false
    if(dateString == false){
      if(!this.disablePinCodeUpdate) {
        this.msg = "Set your pincode."
        this.showDialog = true
      }
      return;
    }
    const lastUpdatedDate = new Date(dateString)
    const currentDate = new Date()
    const diffTime = Math.abs(currentDate.getTime()- lastUpdatedDate.getTime()) 
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
    if(diffDays > 30 && !this.disablePinCodeUpdate)
    {
      this.showDialog = true
      this.msg = "Reset your pincode."
    }
  }

  getTitle(){
    if (this.authService.user === undefined || this.authService.user === null){
      return ''
    }
    else {
      return "Update Pin ("+this.authService.user.email+")"
    }
    
  }

  validatePincode(){
    const pincode = this.pincode
    const confirmPincode = this.confirmPincode
    if(
     ((pincode.length < 6)
    || (pincode.length > 10) 
    || !(pincode == confirmPincode))
    || !((/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]/).test(pincode))
    ){
      return true
    }
    else{
      return false
    }

  }

}